import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import useHttp from './useHttp';
import { fetchDataAsync } from './utilities';
import { FetchRequest, FetchResponse } from './types';
import { DEFAULT_HEADERS } from './constants';
import settings from '../../config';


const useFetchOnLoad = <T>(request: FetchRequest<T>): FetchResponse => {
    const {getAccessTokenSilently} = useAuth0();
    const { onComplete, queryParameters, url } = request;
    const { error, fetchStatus, sendRequest } = useHttp();
    
    useEffect(() => {
        fetchDataAsync(url, sendRequest, onComplete, DEFAULT_HEADERS, url.startsWith(settings.API_URL) ? getAccessTokenSilently : null, queryParameters).catch((err) => {
            console.error(`Unhandled error: ${err}`);
        });
    }, []);
    return { error, fetchStatus };
};

export default useFetchOnLoad;